import type { AccountRelationshipType } from '@cdf/api-client-react';

import { Badge } from '@/components/ui/badge';

export const ACCOUNT_RELATIONSHIP_OPTIONS: ReadonlyArray<{
  value: AccountRelationshipType;
  label: string;
  pluralLabel: string;
}> = [
  { value: 'b2b_customer', label: 'B2B customer', pluralLabel: 'B2B customers' },
  { value: 'b2c_consumer', label: 'B2C consumer', pluralLabel: 'Consumers' },
  { value: 'partner', label: 'Partner', pluralLabel: 'Partners' },
  { value: 'supplier', label: 'Supplier', pluralLabel: 'Suppliers' },
  { value: 'investor', label: 'Investor', pluralLabel: 'Investors' },
  { value: 'prospect', label: 'Prospect', pluralLabel: 'Prospects' },
  { value: 'other', label: 'Other', pluralLabel: 'Other' }
];

export const ACCOUNT_RELATIONSHIP_LABELS: Record<AccountRelationshipType, string> =
  Object.fromEntries(
    ACCOUNT_RELATIONSHIP_OPTIONS.map(({ value, label }) => [value, label])
  ) as Record<AccountRelationshipType, string>;

export function AccountRelationshipBadge({ value }: { value: AccountRelationshipType }) {
  return <Badge variant="outline">{ACCOUNT_RELATIONSHIP_LABELS[value]}</Badge>;
}
